document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-main-product]').forEach(function (root) {
    initGallery(root);
    initVariantPills(root);
    initFloatingBuyButton(root);
    if (window.wireAccordion) {
      window.wireAccordion(
        '.acc-head',
        '.acc-item',
        '.acc-panel'
      );
    }
  });

  // ---- Galeria (carrossel dinâmico, qualquer quantidade de mídia) ----
  function initGallery(root) {
    var track = root.querySelector('[data-media-track]');
    if (!track) return;
    var slides = root.querySelectorAll('.media-slide');
    var thumbs = root.querySelectorAll('.thumb');
    var dots = root.querySelectorAll('[data-media-dots] span');
    var prevBtn = root.querySelector('[data-media-prev]');
    var nextBtn = root.querySelector('[data-media-next]');
    var hint = root.querySelector('[data-swipe-hint]');

    function goToIndex(index) {
      if (!slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function currentIndex() {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      return Math.min(Math.max(idx, 0), slides.length - 1);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goToIndex(i); });
    });
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex((currentIndex() - 1 + slides.length) % slides.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex((currentIndex() + 1) % slides.length);
      });
    }
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () { setActive(currentIndex()); }, 80);
      if (hint) hint.style.opacity = '0';
    }, { passive: true });
  }

  // ---- Pílulas de variante, uma fileira por opção ----
  //
  // Cada fileira é uma opção do produto (Cor, Tamanho). A variante é o
  // CRUZAMENTO das escolhas, então nenhuma pílula sozinha sabe o preço: o JS
  // lê os valores marcados, procura no mapa de variantes a que casa com
  // todos eles e reescreve o bloco de oferta.
  //
  // O Liquid já entrega a página com a variante certa escolhida, o preço
  // certo na tela e o id certo no formulário — e os preços já vêm formatados
  // pelo filtro money. Nada de conta de dinheiro em JavaScript, e se este
  // arquivo falhar a página continua vendendo a variante inicial.
  function initVariantPills(root) {
    var picker = root.querySelector('[data-vpicker]');
    var dataEl = root.querySelector('[data-vdata]');
    if (!picker || !dataEl) return;

    var variants, notes, initial;
    try {
      variants = JSON.parse(dataEl.textContent);
      initial = JSON.parse(picker.dataset.initial || '[]');
      var notesEl = root.querySelector('[data-vnotes]');
      notes = notesEl ? JSON.parse(notesEl.textContent) : {};
    } catch (err) {
      return; // JSON quebrado não pode derrubar o botão de compra
    }
    if (!variants || !variants.length) return;

    var radios = [].slice.call(picker.querySelectorAll('.vpill-input'));
    if (!radios.length) return;

    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var atcButton = root.querySelector('[data-atc-button]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var elPrice = root.querySelector('[data-offer-price]');
    var elWas = root.querySelector('[data-offer-was]');
    var elOff = root.querySelector('[data-offer-off]');
    var elNote = root.querySelector('[data-offer-note]');
    var elWarn = root.querySelector('[data-offer-soldout]');

    // Valor vazio esconde o nó em vez de deixar um resto da variante
    // anterior na tela.
    function setNode(node, value) {
      if (!node) return;
      if (value) {
        node.textContent = value;
        node.hidden = false;
      } else {
        node.textContent = '';
        node.hidden = true;
      }
    }

    // Parte do que o Liquid escolheu e sobrescreve só as posições que têm
    // fileira. Opção de valor único não vira pílula, então o valor dela
    // precisa vir daqui.
    function selection() {
      var sel = initial.slice();
      radios.forEach(function (r) {
        if (r.checked) sel[+r.dataset.optionIndex] = r.value;
      });
      return sel;
    }

    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (o[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    // Apaga as pílulas que, junto com o resto do que já está escolhido, não
    // levam a nenhuma variante com estoque. Elas continuam clicáveis de
    // propósito: travar o clique faz o tamanho "sumir" sem explicação.
    function dim(sel) {
      radios.forEach(function (r) {
        var test = sel.slice();
        test[+r.dataset.optionIndex] = r.value;
        var v = match(test);
        var pill = r.closest('.vpill');
        if (pill) pill.classList.toggle('is-soldout', !r.checked && (!v || !v.available));
      });
    }

    function apply() {
      var sel = selection();

      radios.forEach(function (r) {
        var pill = r.closest('.vpill');
        if (pill) pill.classList.toggle('is-active', r.checked);
      });

      dim(sel);

      // Observação: o primeiro valor escolhido que tenha texto cadastrado.
      var note = '';
      for (var i = 0; i < sel.length; i++) {
        if (notes[sel[i]]) { note = notes[sel[i]]; break; }
      }
      setNode(elNote, note);

      var v = match(sel);

      if (!v) {
        if (elWarn) { elWarn.textContent = 'Essa combinação não está disponível'; elWarn.hidden = false; }
        if (atcButton) atcButton.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Indisponível';
        return;
      }

      if (variantIdInput) variantIdInput.value = v.id;
      if (elPrice) elPrice.textContent = v.price;
      setNode(elWas, v.compare);
      setNode(elOff, v.off);

      if (elWarn) {
        elWarn.textContent = 'Esgotado no momento';
        elWarn.hidden = v.available;
      }
      if (atcButton) atcButton.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
    }

    radios.forEach(function (r) { r.addEventListener('change', apply); });

    // Já no carregamento: pílula sem estoque nasce apagada.
    dim(selection());
  }

  // ---- Botão flutuante "Ver opções" ----
  function initFloatingBuyButton(root) {
    var atcButton = root.querySelector('[data-atc-button]');
    if (!atcButton || !('IntersectionObserver' in window)) return;

    var floatBtn = document.createElement('button');
    floatBtn.type = 'button';
    floatBtn.className = 'floating-buy-btn';
    floatBtn.textContent = 'Ver opções';
    document.body.appendChild(floatBtn);

    floatBtn.addEventListener('click', function () {
      atcButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          floatBtn.classList.remove('is-visible');
        } else {
          // só mostra se o botão já saiu por CIMA da tela (rolou pra baixo demais),
          // não quando ele ainda nem apareceu (topo da página)
          var scrolledPast = entry.boundingClientRect.bottom < 0;
          floatBtn.classList.toggle('is-visible', scrolledPast);
        }
      });
    }, { threshold: 0 });
    observer.observe(atcButton);
  }
});
